import React from "react"
import { Badge } from "react-bootstrap"
import { injectIntl } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import { onboardingApplicationStatusType, ONBOARDING_APPLICATION_STATUS, paymentAccountStatusType, PAYMENT_ACCOUNT_STATUS } from "../../utils"
import { badgeMessages } from "./BadgeMessages"

type badgeStatus = onboardingApplicationStatusType | paymentAccountStatusType

type badgeProps = {
    status: badgeStatus
}
  
const PaymentAccountBadge = (props: badgeProps & IntlProps) => {    
    
    const statusLabels: Record<badgeStatus, string> = {
        [ONBOARDING_APPLICATION_STATUS.IN_PROGRESS]: "inProgress",
        [ONBOARDING_APPLICATION_STATUS.CREATED]: "created",
        [ONBOARDING_APPLICATION_STATUS.DECLINED]: "declined",
        [ONBOARDING_APPLICATION_STATUS.IN_REVIEW]: "inReview",
        [ONBOARDING_APPLICATION_STATUS.PROCESSING]: "processing",
        [ONBOARDING_APPLICATION_STATUS.COMPLETED]: "completed",
        [PAYMENT_ACCOUNT_STATUS.ACTIVE]: "active",
        [PAYMENT_ACCOUNT_STATUS.DEACTIVATED]: "deactivated",
        [PAYMENT_ACCOUNT_STATUS.PENDING]: "pending",
        [PAYMENT_ACCOUNT_STATUS.SUSPENDED]: "suspended",
        [PAYMENT_ACCOUNT_STATUS.ONBOARDING]: "onboarding",
    }

    const defaultStatus = "default"
    const getLabel = (status: badgeStatus) => statusLabels[status] || defaultStatus

    const getVariant = (status: badgeStatus): string => {
        switch (status) {
        case PAYMENT_ACCOUNT_STATUS.PENDING:
            return "secondary"
        case ONBOARDING_APPLICATION_STATUS.CREATED:
        case ONBOARDING_APPLICATION_STATUS.COMPLETED:
        case PAYMENT_ACCOUNT_STATUS.ACTIVE:
            return "success"
        case ONBOARDING_APPLICATION_STATUS.DECLINED:
        case PAYMENT_ACCOUNT_STATUS.DEACTIVATED:
            return "danger"
        case PAYMENT_ACCOUNT_STATUS.SUSPENDED:
            return "warning"
        case ONBOARDING_APPLICATION_STATUS.PROCESSING:
        case ONBOARDING_APPLICATION_STATUS.IN_PROGRESS:
            return "info"
        default:
            return "primary"
        }
    }
      
    return <Badge variant={getVariant(props.status)}>
        {props.intl.formatMessage(badgeMessages[getLabel(props.status)])}
    </Badge>
}
export default injectIntl(PaymentAccountBadge)


// WEBPACK FOOTER //
// ./src/payment-processing/components/PaymentAccountBadge.tsx